/*
 * @Description: 注册全局自定义指令
 * @Date: 2021-03-22 00:53:10
 */
import { App } from 'vue';

import { XrkLoadingDirective } from 'xrk-components';
import Resource from '@/directives/resource';
import Copy from '@/directives/copy';

export function setupDirectives(app: App) {
  app.directive(XrkLoadingDirective.name, XrkLoadingDirective.directive);
  app.directive('resource', Resource);
  app.directive('copy', Copy);
}
